import { render, staticRenderFns } from "./SNotificationCenter.vue?vue&type=template&id=12b14910&scoped=true&"
import script from "./SNotificationCenter.vue?vue&type=script&lang=js&"
export * from "./SNotificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./SNotificationCenter.vue?vue&type=style&index=0&id=12b14910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b14910",
  null
  
)

export default component.exports